export default __webpack_public_path__ + "static/media/border.9d043f56.png";